<route>
{
  "name": "Unidade"
}
</route>
<template>
  <div>
    <loading :active.sync="loading" color="#5e72e4"></loading>
    <base-header class="header pb-8 pt-3 pt-lg-7 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-info opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row justify-content-between align-items-center" style="flex-basis: 100%;" v-if="unidade.id">
          <div class="position-relative">
            <h4 class="h4 text-uppercase text-white pt-1">{{ (unidade.condominio || {}).nome }}</h4>
            <h1 class="display-4 text-white pt-1">Unidade {{ unidade.descricao }}</h1>
            <p v-if="unidade.precisaConfirmarDados"
              class="text-white mt-0 mb-2"
            >Antes que seguir para o portal, precisamos que você confirme os dados da unidade.</p>
          </div>
          <div>
            <base-button v-if="unidade.precisaConfirmarDados" type="success" icon="fa fa-save" @click="confirmarDados">Confirmar Dados</base-button>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7 mb-2" v-if="!loading">
      <div class="row">
        <div class="col-xl-12">
          <card shadow type="secondary" bodyClasses="py-2">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center justify-content-between px-2">
                <div>
                  <h3 class="mb-0">Contato de Emergência</h3>
                </div>
              </div>
            </div>
            <template>
              <form @submit.prevent>
                <div class="pl-0">
                  <div class="row justify-content-between align-items-center">
                    <div class="col-sm-4 col-6">
                      <base-input
                        alternative
                        label="Nome"
                        required
                        placeholder="Nome"
                        input-classes="form-control-alternative"
                        v-model="contatoEmergencia.nome"
                      />
                    </div>
                    <div class="col-sm-4 col-6">
                       <base-input
                        alternative
                        label="Telefone"
                        placeholder="(99) 99999-9999"
                        type="tel"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        input-classes="form-control-alternative"
                        v-model="contatoEmergencia.telefone"
                      />
                    </div>
                    <div class="col-4">
                      <base-button :disabled="!contatoEmergenciaAlterado" type="success" @click="salvarContatoEmergencia">Salvar</base-button>
                    </div>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-if="!loading">
      <div class="row">
        <div class="col-xl-6 order-xl-1 pb-2">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center justify-content-between px-2">
                <div>
                  <h3 class="mb-0">Inquilino</h3>
                </div>
                <div v-if="unidade.estaAlugado || informarDadosInquilino">
                  <base-button @click="confirmarRemoverInquilino" rounded icon-only icon="fa fa-trash" type="danger"></base-button>
                </div>
              </div>
            </div>
            <template v-if="unidade.estaAlugado || informarDadosInquilino">
              <form @submit.prevent>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-12">
                      <base-input
                        alternative
                        label="Nome"
                        required
                        placeholder="Nome"
                        input-classes="form-control-alternative"
                        v-model="inquilino.nome"
                      />
                    </div>
                    <div class="col-12">
                      <base-input
                        alternative
                        required
                        label="Email"
                        placeholder="seuemail@provedor.com"
                        input-classes="form-control-alternative"
                        v-model="inquilino.email"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="Celular"
                        placeholder="(99) 99999-9999"
                        type="tel"
                        v-mask="'(##) #####-####'"
                        input-classes="form-control-alternative"
                        v-model="inquilino.celular"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="Telefone"
                        placeholder="(99) 99999-9999"
                        type="tel"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        input-classes="form-control-alternative"
                        v-model="inquilino.telefone"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="CPF/CNPJ"
                        placeholder="999.999.999-99"
                        type="tel"
                        v-mask="['###.###.###-##', '##.###.###/####-##']"
                        input-classes="form-control-alternative"
                        v-model="inquilino.cpfCnpj"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="RG"
                        placeholder="RG"
                        input-classes="form-control-alternative"
                        v-model="inquilino.rg"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                      alternative
                      label="Data de Nascimento"
                      >
                        <v-date-picker
                          ref="dataReserva"
                          :input-props="{ class: 'form-control form-control-alternative' }"
                          :popover="{ visibility: 'focus' }"
                          locale="pt-PT"
                          v-model="inquilino.dataNascimento"
                        ></v-date-picker>
                      </base-input>
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <base-button type="success" :disabled="!inquilinoAlterado" @click="salvarInquilino">Salvar</base-button>
                </div>
              </form>
            </template>
            <base-button v-else type="primary" size="sm" icon="fa fa-plus" @click="() => informarDadosInquilino = true">Informar dados do Inquilino</base-button>
          </card>
        </div>
        <div class="col-xl-6 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row justify-content-between align-items-center px-2">
                <div class="">
                  <h3 class="mb-0">Imobiliária/Administradora</h3>
                </div>
                <div v-if="!imobiliaria.estaVazio || informarDadosImobiliaria">
                  <base-button @click="confirmarRemoverImobiliaria" rounded icon-only icon="fa fa-trash" type="danger"></base-button>
                </div>
              </div>
            </div>
            <template v-if="!imobiliaria.estaVazio || informarDadosImobiliaria">
              <form @submit.prevent>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="Nome"
                        placeholder="Nome"
                        input-classes="form-control-alternative"
                        v-model="imobiliaria.nome"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="Email"
                        placeholder="seuemail@provedor.com"
                        input-classes="form-control-alternative"
                        v-model="imobiliaria.email"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="Telefone"
                        placeholder="(99) 99999-9999"
                        type="tel"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        input-classes="form-control-alternative"
                        v-model="imobiliaria.telefone"
                      />
                    </div>
                  </div>
                  <endereco v-model="imobiliaria.endereco"></endereco>
                </div>
                <div class="text-right">
                  <base-button type="success" :disabled="!imobiliariaAlterada" @click="salvarImobiliaria">Salvar</base-button>
                </div>
              </form>
            </template>
            <base-button v-else type="primary" size="sm" icon="fa fa-plus" @click="() => informarDadosImobiliaria = true">Informar dados da Imobiliária</base-button>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { diff } from "deep-diff";
import { mapGetters, mapActions } from "vuex";
import Endereco from "../../../components/Endereco";

export default {
  components: { Endereco },
  data() {
    return {
      unidade: {},
      inquilino: {},
      imobiliaria: {},
      contatoEmergencia: {},
      loading: true,
      informarDadosImobiliaria: false,
      informarDadosInquilino: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['unidadesPendentesConfirmacao']),
    indiceUnidadeLista() {
      return this.unidadesPendentesConfirmacao.findIndex(u => u.id === Number(this.$route.params.id))
    },
    contatoEmergenciaAlterado() {
      return (
        Boolean(diff(this.contatoEmergencia, { nome: this.unidade.nomeContatoEmergencia, telefone: this.unidade.telefoneContatoEmergencia }))
      );
    },
    inquilinoAlterado() {
      return (
        Boolean(diff(this.inquilino, this.unidade.inquilino))
      );
    },
    imobiliariaAlterada() {
      return (
        Boolean(diff(this.imobiliaria, this.unidade.imobiliaria))
      );
    },
  },
  created() {
    this.carregarUnidade();
  },
  methods: {
    ...mapActions('auth', ['recarregarNovoPerfil']),
    salvarContatoEmergencia() {
      this.loading = true;
      this.$http.post(`/api/v2/unidades/${this.$route.params.id}/emergencia`, this.contatoEmergencia).then(() => {
        this.carregarUnidade();
      });
    },
    salvarInquilino() {
      this.loading = true;
      this.$http.post(`/api/v2/unidades/${this.$route.params.id}/inquilino`, this.inquilino).then(() => {
        this.carregarUnidade();
      });
    },
    salvarImobiliaria() {
      this.loading = true;
      this.$http.post(`/api/v2/unidades/${this.$route.params.id}/imobiliaria`, this.imobiliaria).then(() => {
        this.carregarUnidade();
      });
    },
    confirmarRemoverImobiliaria() {
      if (!this.imobiliaria.estaVazio) {
        this.$confirm('Você tem certeza que deseja remover os dados da imobiliária?').then((result) => {
          if (result.value) {
            this.removerImobiliaria();
          }
        });
      }
      this.informarDadosImobiliaria = false;
    },
    confirmarRemoverInquilino() {
      if (this.unidade.estaAlugado) {
        this.$confirm('Você tem certeza que deseja remover os dados do inquilino?').then((result) => {
          if (result.value) {
            this.removerInquilino();
          }
        }); 
      }
      this.informarDadosInquilino = false;
    },
    removerInquilino() {
      this.loading = true;
      this.$http.delete(`/api/v2/unidades/${this.$route.params.id}/inquilino`).then(() => {
        this.carregarUnidade();
      });
    },
    removerImobiliaria() {
      this.loading = true;
      this.$http.delete(`/api/v2/unidades/${this.$route.params.id}/imobiliaria`).then(() => {
        this.carregarUnidade();
      });
    },
    confirmarDados() {
      this.loading = true;
      this.$http.post(`/api/v2/unidades/${this.$route.params.id}/confirmacao-dados`).then(() => {
        this.recarregarNovoPerfil().then(() => {
          this.loading = false;
          if (this.unidadesPendentesConfirmacao.length > 0) {
            this.$router.push(`/unidades/${this.unidadesPendentesConfirmacao[0].id}`);
          } else {
            this.$router.push('/')
          }
        });
      });
    },
    carregarUnidade() {
      this.loading = true;
      this.$http.get(`/api/v2/unidades/${this.$route.params.id}`).then((res) => {
        res.data.inquilino.dataNascimento = new Date(res.data.inquilino.dataNascimento);
        this.$set(this, 'unidade', res.data);
        this.$set(this, 'inquilino', {...res.data.inquilino});
        this.$set(this, 'imobiliaria', {...(res.data.imobiliaria || {})});
        this.$set(this, 'contatoEmergencia', { nome: res.data.nomeContatoEmergencia, telefone: res.data.telefoneContatoEmergencia });
        this.loading = false;
      });
    },
  },
};
</script>
